export function extractErrorMessage(error) {
  const errorData = error;

  if (typeof errorData === "string") {
    return errorData
      .split(/,\n|\n/)
      .map((msg) => msg.trim().replace(/^Validation error:\s*\w+:\s*/g, ""))
      .filter(Boolean)
      .join("\n");
  }

  return "Ocorreu um erro inesperado. Tente novamente.";
}
